"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5437],{

/***/ 6838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3887);


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  position: relative;\n  padding-left: 28px;\n  font-size: 14px;\n  line-height: 20px;\n  color: ",
        ";\n  user-select: none;\n  cursor: pointer;\n\n  ",
        " {\n    &:hover input ~ span {\n      background: ",
        ";\n    }\n  }\n\n  &:active input ~ span {\n    background: ",
        ";\n\n    @media (hover: hover) {\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    }\n  }\n\n  input {\n    position: absolute;\n    opacity: 0;\n    height: 0;\n    width: 0;\n    cursor: pointer;\n\n    &:checked ~ span {\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    }\n\n    &:checked ~ span::after {\n      opacity: 1;\n    }\n\n    &:disabled ~ span {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  span {\n    position: absolute;\n    top: -1px;\n    left: 0;\n    height: 22px;\n    width: 22px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 2px;\n    transition: background 0.1s ease, border 0.1s ease;\n\n    &::after {\n      content: '';\n      position: absolute;\n      left: 6px;\n      top: 2px;\n      width: 8px;\n      height: 12px;\n      border: 1px solid ",
        ";\n      border-width: 0 2px 2px 0;\n      opacity: 0;\n      transform: rotate(45deg);\n      transition: opacity 0.1s ease;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 체크박스
 * @param props
 * @param props.label 라벨 (id)
 * @param props.message 체크박스 메세지
 * @param props.checked 체크 여부
 * @param props.disabled 비활성화 여부
 *
 * @example
 * <CheckBox
 *   name="체크박스명"
 *   label="라벨명"
 *   message="로그인 상태 유지"
 * />
 */ var CheckBox = function(_param) {
    var label = _param.label, message = _param.message, checked = _param.checked, disabled = _param.disabled, props = _objectWithoutProperties(_param, [
        "label",
        "message",
        "checked",
        "disabled"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
        htmlFor: label,
        disabled: disabled,
        children: [
            message,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                id: label,
                type: "checkbox",
                checked: checked,
                disabled: disabled
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
        ]
    }));
};
var Label = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-c7451c6d-0"
})(_templateObject(), function(props) {
    return props.disabled ? cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.font.tertiary2 */ .DG.font.tertiary2 : cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.font.tertiary1 */ .DG.font.tertiary1;
}, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .onlyHover */ .kC, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey010 */ .DG.grey010, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey010 */ .DG.grey010, function(props) {
    return props.disabled ? cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.white */ .DG.white : cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040;
}, function(props) {
    return props.disabled ? cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey030 */ .DG.grey030 : cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040;
}, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey030 */ .DG.grey030, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.white */ .DG.white, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey040 */ .DG.grey040, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.white */ .DG.white);
/* harmony default export */ __webpack_exports__["Z"] = (CheckBox);


/***/ }),

/***/ 5437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7379);
/* harmony import */ var cds_forms_CheckBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6838);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5549);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6643);
/* harmony import */ var slices_user_thunk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9001);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8004);
/* harmony import */ var lib_utils_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4058);
/* harmony import */ var hooks_domain_review_useRedirectUrl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3225);
/* harmony import */ var cds_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(506);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3887);




// compnents



// slices

// hooks



// styles


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 530px;\n  padding: 16px;\n  margin: 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 386px;\n  margin: 0 auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 50px;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: 34px;\n  text-align: center;\n  color: ",
        ";\n  ",
        " {\n    font-size: 24px;\n    line-height: 42px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  z-index: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin: ",
        ";\n\n  & > label {\n    color: ",
        ";\n  }\n\n  span {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 58px;\n  margin: 0 0 20px;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 5px;\n  font-size: 16px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n\n  &:disabled {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &:active {\n    filter: brightness(90%);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  ",
        "\n\n  & > span {\n    color: ",
        ";\n  }\n\n  & > button {\n    padding: 0 6px;\n    color: ",
        ";\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  height: 36px;\n  padding: 0 10px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0);\n  text-align: center;\n  line-height: 32px;\n  font-size: 14px;\n  font-weight: 400;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 14px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n\n  &:disabled {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &:active {\n    opacity: 0.6;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 6px;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  margin-bottom: 16px;\n  font-size: 16px;\n\n  /* &:last-of-type {\n    margin-bottom: 10px;\n  } */\n\n  & label {\n    display: block;\n    padding-left: 14px;\n    margin-bottom: 6px;\n    color: ",
        ";\n  }\n\n  & i {\n    color: ",
        ";\n  }\n\n  & > div {\n    position: relative;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n          & div:first-of-type {\n            input {\n              border-bottom-left-radius: 0;\n              border-bottom-right-radius: 0;\n            }\n          }\n        "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n\n  & label {\n    display: block;\n    padding-left: 14px;\n    margin-bottom: 6px;\n    color: ",
        ";\n\n    & i {\n      color: ",
        ";\n    }\n  }\n\n  & > div {\n    position: relative;\n  }\n\n  ",
        "\n\n  & div ~ div input {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  & button,\n  & a,\n  & p,\n  & span {\n    z-index: 2;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 52px;\n  padding: 0 14px;\n  border: none;\n  outline: none;\n  border-radius: 8px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 12px;\n  background-color: ",
        ";\n  color: ",
        ";\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    box-shadow: 0 0 0 30px white inset !important;\n  }\n\n  &:focus {\n    position: relative;\n    border: 1px solid ",
        ";\n    z-index: 1;\n  }\n\n  &:placeholder-shown {\n    text-overflow: ellipsis;\n  }\n  s &::placeholder {\n    color: ",
        ";\n    font-size: inherit;\n  }\n\n  &:focus::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding: 0 112px 0 14px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding: 0 76px 0 14px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: absolute;\n  align-items: center;\n  justify-content: flex-end;\n  height: 52px;\n  padding: ",
        ";\n  top: 0;\n  right: 0;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 14px;\n  margin-top: 5px;\n  ",
        "\n  color: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  & > div:first-of-type > div:last-of-type {\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
/**
 * 오직 숫자값 리턴하기
 * @param {number} value
 * @returns number
 */ function setOnlyNumbers(value) {
    return value.replace(/[^\d*]/g, '');
}
/**
 * 시작, 끝 여백 지우기
 * @param {number} value
 * @returns value
 */ function setTrimValue(value) {
    return value.trim();
}
function removeSpecialCharacter(value) {
    return value.replace(/[~`₩!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/g, '');
}
/**
 * 휴대폰 회원가입 페이지
 * @param {object} props
 * @param {Func} props.onSignin         휴대폰 번호 로그인 페이지 이동 이벤트
 * @param {Func} props.onSigninSocial   소셜 로그인 페이지 이동 이벤트
 */ var SignupPhone = function(param) {
    var onSignin = param.onSignin, onSigninSocial = param.onSigninSocial;
    var dispatch = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), nickname = ref[0], setNickname = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), phoneNumber = ref1[0], setPhoneNumber = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), password = ref2[0], setPassword = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), verifyPassword = ref3[0], setVerifyPassword = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), certificationNumber = ref4[0], setCertificationNumber = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isTos = ref5[0], setIsTos = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isWrongPhoneNumber = ref6[0], setIsWrongPhoneNumber = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isRequestCertification = ref7[0], setIsRequestCertification = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isVisibleValidMessageOfCertification = ref8[0], setIsVisibleValidMessageOfCertification = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isVisiblePassword = ref9[0], setIsVisiblePassword = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isVisibleVerifyPassword = ref10[0], setIsVisibleVerifyPassword = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isVisibleValidMessageOfNickname = ref11[0], setIsVisibleValidMessageOfNickname = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isVisibleValidMessageOfPassword = ref12[0], setIsVisibleValidMessageOfPassword = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isVisibleValidMessageOfVerifyPassword = ref13[0], setIsVisibleValidMessageOfVerifyPassword = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSendAuth = ref14[0], setIsSendAuth = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isReSendAuth = ref15[0], setIsReSendAuth = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('ready'), authMessage = ref16[0], setAuthMessage = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isPeriod = ref17[0], setIsPeriod = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isSubmitDisabled = ref18[0], setIsSubmitDisabled = ref18[1];
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), queryParams = ref19[0], setQueryParams = ref19[1];
    var certificationTimer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var availableTime = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var redirectUrl = (0,hooks_domain_review_useRedirectUrl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().redirectUrl;
    var isPhoneNumberValid = phoneNumber.length >= 11;
    var isCertificationNumberValid = certificationNumber.length >= 4;
    var onKeyUp = function(e) {
        if (isSubmitDisabled) {
            return;
        }
        if (e.keyCode !== 13) {
            return;
        }
        formRef.current.submit();
    };
    /** 닉네임 인풋 이벤트 */ var onInputNickname = function(e) {
        var value = e.target.value;
        setNickname(removeSpecialCharacter(setTrimValue(value)));
        setIsVisibleValidMessageOfNickname(false);
    };
    var onBlurNickname = function(e) {
        var value = e.target.value;
        if (setTrimValue(value).length >= 2) {
            return;
        }
        setIsVisibleValidMessageOfNickname(true);
    };
    /** 휴대폰 번호 인풋 이벤트 */ var onInputPhoneNumber = function(e) {
        var value = e.target.value;
        setPhoneNumber(setOnlyNumbers(value));
        setIsWrongPhoneNumber(false);
        setIsRequestCertification(false);
    };
    var onBlurPhoneNumber = function(e) {
        var value = e.target.value;
        if (value.length >= 11) {
            return;
        }
        setIsWrongPhoneNumber(true);
    };
    /** 인증번호 인풋 이벤트 */ var onInputCertificationNumber = function(e) {
        var value = e.target.value;
        setCertificationNumber(setOnlyNumbers(value));
        setIsVisibleValidMessageOfCertification(false);
    };
    /** 비밀번호 토글 */ var onTogglePassword = function() {
        setIsVisiblePassword(function(v) {
            return !v;
        });
    };
    /** 확인용 비밀번호 토글 */ var onToggleVerifyPassword = function() {
        setIsVisibleVerifyPassword(function(v) {
            return !v;
        });
    };
    /** 인증 번호 발송 요청 이벤트 */ var onRequestAuth = function() {
        setIsPeriod(false);
        dispatch((0,slices_user_thunk__WEBPACK_IMPORTED_MODULE_6__/* .postSendAuth */ .k5)({
            phone: phoneNumber
        }));
    };
    /** 인증 번호 발송 요청 */ var onAuth = function() {
        setIsRequestCertification(false);
        setIsSendAuth(true);
        onRequestAuth();
    };
    /** 인증 번호 재발송 요청 */ var onReSendAuth = function() {
        setIsRequestCertification(false);
        setIsReSendAuth(false);
        onRequestAuth();
    };
    /** 인증 번호 확인 */ var onCheckAuth = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!isPhoneNumberValid && !isCertificationNumberValid)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return dispatch((0,slices_user_thunk__WEBPACK_IMPORTED_MODULE_6__/* .postCheckSmsAuth */ .kX)({
                            hpno: phoneNumber,
                            authno: certificationNumber
                        }));
                    case 4:
                        res = _ctx.sent;
                        if (res.payload.message !== 'success') {
                            setCertificationNumber('');
                            setIsVisibleValidMessageOfCertification(true);
                        }
                        setAuthMessage(res.payload.message);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onCheckAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    /** 비밀번호 인풋 이벤트 */ var onInputPassword = function(e) {
        var value = e.target.value;
        setPassword(value);
        setIsVisibleValidMessageOfPassword(false);
    };
    var onBlurPassword = function(e) {
        var value = e.target.value;
        if (value.length >= 6) {
            return;
        }
        setIsVisibleValidMessageOfPassword(true);
    };
    /** 확인 비밀번호 인풋 이벤트 */ var onInputVerifyPassword = function(e) {
        var value = e.target.value;
        setVerifyPassword(value);
        setIsVisibleValidMessageOfVerifyPassword(false);
    };
    var onBlurVerifyPassword = function(e) {
        var value = e.target.value;
        if (password === value) {
            return;
        }
        setIsVisibleValidMessageOfVerifyPassword(true);
    };
    /** 인증 유효 시간 작업 */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isSendAuth) {
            return;
        }
        var initTimer = function() {
            window.clearTimeout(certificationTimer.current);
            certificationTimer.current = null;
            setIsReSendAuth(true);
            setIsPeriod(true);
        };
        if (authMessage === 'success') {
            return initTimer();
        }
        if (certificationTimer.current) {
            return;
        }
        var target = availableTime.current;
        var onTimer = function(time) {
            if (time === 0 && authMessage !== 'success') {
                setCertificationNumber('');
                setIsVisibleValidMessageOfCertification(false);
            }
            if (time <= 0 || isPeriod) {
                initTimer();
            } else {
                var minute = Math.floor(time / 60);
                var second = time % 60 < 10 ? "0".concat(time % 60) : time % 60;
                target.textContent = "".concat(minute, ":").concat(second);
                certificationTimer.current = window.setTimeout(function() {
                    return onTimer(time - 1);
                }, 1000);
            }
        };
        onTimer(60 * 3);
        return function() {
            if (authMessage !== 'success') {
                return;
            }
            window.clearTimeout(certificationTimer.current);
        };
    }, [
        isSendAuth,
        availableTime,
        authMessage,
        isPeriod
    ]);
    /** 리턴 url 설정 */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .isExistWindow */ .br)()) {
            return;
        }
        var params = window.location.search;
        if (params) {
            setQueryParams(params);
            return;
        }
        if (redirectUrl.indexOf('/user/sigin') > -1) {
            return;
        }
        setQueryParams("?url=".concat(redirectUrl));
    }, [
        redirectUrl
    ]);
    /** 회원가입 완료 버튼 활성화 */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isValid = nickname.length >= 2 && authMessage === 'success' && password && password === verifyPassword && isTos;
        if (isValid) {
            return setIsSubmitDisabled(false);
        }
        return setIsSubmitDisabled(true);
    }, [
        nickname,
        authMessage,
        password,
        verifyPassword,
        isTos
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Section, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Inner, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                        children: "회원가입"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Form, {
                        ref: formRef,
                        method: "POST",
                        action: "".concat("https://www.classu.co.kr", "/modoo/registerUser").concat(queryParams),
                        acceptCharset: "UTF-8",
                        target: "_top",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Field, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                htmlFor: "username",
                                                children: [
                                                    "닉네임",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Input, {
                                                        id: "username",
                                                        name: "username",
                                                        type: "text",
                                                        minLength: "2",
                                                        maxLength: "8",
                                                        autoComplete: "username",
                                                        placeholder: "닉네임을 입력해주세요 (8자 제한)",
                                                        value: nickname,
                                                        onInput: onInputNickname,
                                                        onKeyUp: onKeyUp,
                                                        onBlur: onBlurNickname,
                                                        required: true
                                                    }),
                                                    isVisibleValidMessageOfNickname && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Valid, {
                                                        children: "닉네임은 최소 2자 입력해주세요"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Authenticate, {
                                        active: isSendAuth,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                htmlFor: "phone",
                                                children: [
                                                    "휴대폰 번호",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PhoneInputField, {
                                                        id: "phone",
                                                        name: "phone",
                                                        type: "tel",
                                                        inputMode: "numeric",
                                                        maxLength: "11",
                                                        autoComplete: "tel",
                                                        placeholder: "숫자만 입력해 주세요",
                                                        readOnly: isSendAuth && !isReSendAuth || authMessage === 'success',
                                                        required: true,
                                                        value: phoneNumber,
                                                        onInput: onInputPhoneNumber,
                                                        onKeyUp: onKeyUp,
                                                        onBlur: onBlurPhoneNumber
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AddOns, {
                                                        isSendAuth: isSendAuth,
                                                        children: [
                                                            !isSendAuth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AuthorizingButton, {
                                                                type: "button",
                                                                onClick: onAuth,
                                                                disabled: !isPhoneNumberValid,
                                                                children: "인증요청"
                                                            }),
                                                            isReSendAuth && isPeriod && authMessage !== 'success' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReAuthorizingButton, {
                                                                type: "button",
                                                                onClick: onReSendAuth,
                                                                disabled: !isPhoneNumberValid,
                                                                children: "인증번호 재발송"
                                                            }),
                                                            isSendAuth && !isReSendAuth && !isPeriod && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TimeMessage, {
                                                                ref: availableTime
                                                            })
                                                        ]
                                                    }),
                                                    isWrongPhoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Valid, {
                                                        children: "휴대폰 번호를 입력해주세요"
                                                    })
                                                ]
                                            }),
                                            isSendAuth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AuthInputFeild, {
                                                        name: "authno",
                                                        type: "tel",
                                                        inputMode: "numeric",
                                                        maxLength: "4",
                                                        autoComplete: "one-time-code",
                                                        placeholder: "인증번호 4자리를 입력해 주세요",
                                                        readOnly: !isSendAuth || isReSendAuth || authMessage === 'success',
                                                        required: true,
                                                        value: certificationNumber,
                                                        onInput: onInputCertificationNumber
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AddOns, {
                                                        children: [
                                                            isSendAuth && !isReSendAuth && isCertificationNumberValid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AuthoDo, {
                                                                type: "button",
                                                                tabIndex: "-1",
                                                                onClick: onCheckAuth,
                                                                children: "인증하기"
                                                            }),
                                                            authMessage === 'success' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AuthDoneMessage, {
                                                                children: "인증완료"
                                                            })
                                                        ]
                                                    }),
                                                    isVisibleValidMessageOfCertification && authMessage !== 'success' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Valid, {
                                                        children: authMessage
                                                    })
                                                ]
                                            }),
                                            isRequestCertification && authMessage !== 'success' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Valid, {
                                                children: "휴대폰 번호를 인증해주세요"
                                            })
                                        ]
                                    }),
                                    authMessage === 'success' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Field, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                        htmlFor: "password",
                                                        children: [
                                                            "비밀번호",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Input, {
                                                                id: "password",
                                                                name: "password",
                                                                type: isVisiblePassword ? 'text' : 'password',
                                                                maxLength: "30",
                                                                autoComplete: "new-password",
                                                                placeholder: "비밀번호는 6자리 이상 입력해주세요",
                                                                value: password,
                                                                onInput: onInputPassword,
                                                                onKeyUp: onKeyUp,
                                                                onBlur: onBlurPassword,
                                                                required: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AddOns, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TogglePasswordButton, {
                                                                    type: "button",
                                                                    tabIndex: "-1",
                                                                    onClick: onTogglePassword,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                        name: isVisiblePassword ? 'ic_visible_password' : 'ic_invisible_password',
                                                                        width: 24,
                                                                        height: 24,
                                                                        fill: password.length ? cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey90 */ .DG.grey90 : cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey040 */ .DG.grey040
                                                                    })
                                                                })
                                                            }),
                                                            isVisibleValidMessageOfPassword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Valid, {
                                                                children: "비밀번호는 6자리 이상 입력해주세요"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Field, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                        htmlFor: "password_confirmation",
                                                        children: [
                                                            "비밀번호 확인",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Input, {
                                                                id: "password_confirmation",
                                                                name: "password_confirmation",
                                                                type: isVisibleVerifyPassword ? 'text' : 'password',
                                                                maxLength: "30",
                                                                autoComplete: "new-password",
                                                                placeholder: "비밀번호를 한 번 더 입력해 주세요",
                                                                value: verifyPassword,
                                                                onInput: onInputVerifyPassword,
                                                                onKeyUp: onKeyUp,
                                                                onBlur: onBlurVerifyPassword,
                                                                required: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AddOns, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TogglePasswordButton, {
                                                                    type: "button",
                                                                    tabIndex: "-1",
                                                                    onClick: onToggleVerifyPassword,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                        name: isVisibleVerifyPassword ? 'ic_visible_password' : 'ic_invisible_password',
                                                                        width: 24,
                                                                        height: 24,
                                                                        fill: verifyPassword.length ? cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey90 */ .DG.grey90 : cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey040 */ .DG.grey040
                                                                    })
                                                                })
                                                            }),
                                                            isVisibleValidMessageOfVerifyPassword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Valid, {
                                                                children: "비밀번호가 일치하지 않습니다"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Option, {
                                isValid: isVisibleValidMessageOfVerifyPassword || (isRequestCertification || isVisibleValidMessageOfCertification) && authMessage !== 'success' || isWrongPhoneNumber,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(cds_forms_CheckBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    name: "agree",
                                    label: "tos",
                                    message: "약관 및 개인정보 취급방침 동의",
                                    value: isTos ? '1' : '0',
                                    checked: isTos,
                                    onChange: function() {
                                        return setIsTos(function(v) {
                                            return !v;
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SignupButton, {
                                type: "submit",
                                disabled: isSubmitDisabled ? true : false,
                                children: "완료"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MoreLayout, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                type: "button",
                                onClick: onSignin,
                                children: "로그인"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "│"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                type: "button",
                                onClick: onSigninSocial,
                                children: "다른 방법으로 시작하기"
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var Section = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-6ef1dc5b-0"
})(_templateObject());
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ef1dc5b-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-6ef1dc5b-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey75 */ .DG.grey75, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .mediaQuery.large */ .cy.large);
var TogglePasswordButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6ef1dc5b-3"
})(_templateObject3());
var Option = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ef1dc5b-4"
})(_templateObject4(), function(param) {
    var isValid = param.isValid;
    return isValid ? '16px 0 52px;' : '10px 0 52px;';
}, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey25 */ .DG.grey25, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.BTN.BG */ .DG.BTN.BG, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey0 */ .DG.grey0);
var SignupButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6ef1dc5b-5"
})(_templateObject5(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.Primary.Active */ .DG.Primary.Active, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.white */ .DG.white, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.BTN.BG */ .DG.BTN.BG, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey0 */ .DG.grey0);
var MoreLayout = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ef1dc5b-6"
})(_templateObject6(), cds_typography__WEBPACK_IMPORTED_MODULE_9__/* .body3_regular */ .PD, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey050 */ .DG.grey050, cds_typography__WEBPACK_IMPORTED_MODULE_9__/* .body3_regular */ .PD);
var CertificationStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject7());
var AuthorizingButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6ef1dc5b-7"
})(_templateObject8(), CertificationStyle, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.red040 */ .DG.red040, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.white */ .DG.white, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.BTN.BG */ .DG.BTN.BG, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey0 */ .DG.grey0);
var TimeMessage = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-6ef1dc5b-8"
})(_templateObject9(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.semantic.emphasis */ .DG.semantic.emphasis, cds_typography__WEBPACK_IMPORTED_MODULE_9__/* .body4_regular */ .cm);
var AuthDoneMessage = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-6ef1dc5b-9"
})(_templateObject10(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.semantic.emphasis */ .DG.semantic.emphasis, cds_typography__WEBPACK_IMPORTED_MODULE_9__/* .body4_regular */ .cm);
var Field = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ef1dc5b-10"
})(_templateObject11(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.red040 */ .DG.red040);
var Authenticate = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ef1dc5b-11"
})(_templateObject14(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.red040 */ .DG.red040, function(param) {
    var active = param.active;
    return active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject12()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject13());
});
var InputStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject15(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.system.BNB */ .DG.system.BNB, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey75 */ .DG.grey75, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey060 */ .DG.grey060, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey0 */ .DG.grey0, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.grey0 */ .DG.grey0);
var Input = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-6ef1dc5b-12"
})(_templateObject16(), InputStyles, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.system.grey */ .DG.system.grey);
var PhoneInputField = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-6ef1dc5b-13"
})(_templateObject17(), InputStyles, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.system.grey */ .DG.system.grey);
var AuthInputFeild = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-6ef1dc5b-14"
})(_templateObject18(), InputStyles, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.system.grey */ .DG.system.grey);
var AddOns = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ef1dc5b-15"
})(_templateObject19(), function(param) {
    var isSendAuth = param.isSendAuth;
    return isSendAuth ? '0 14px' : '0 8px';
});
var ReAuthorizingButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6ef1dc5b-16"
})(_templateObject20(), cds_typography__WEBPACK_IMPORTED_MODULE_9__/* .body4_regular */ .cm, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.red060 */ .DG.red060);
var AuthoDo = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6ef1dc5b-17"
})(_templateObject21(), cds_typography__WEBPACK_IMPORTED_MODULE_9__/* .body4_regular */ .cm, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.red060 */ .DG.red060);
var Valid = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ef1dc5b-18"
})(_templateObject22(), cds_typography__WEBPACK_IMPORTED_MODULE_9__/* .body4_regular */ .cm, cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.red060 */ .DG.red060);
var Form = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-6ef1dc5b-19"
})(_templateObject23());
/* harmony default export */ __webpack_exports__["Z"] = (SignupPhone);


/***/ }),

/***/ 3225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7496);


// utils

/**
 * 비로그인시 redirect url을 설정한다.
 *
 * @example
 * const { redirectUrl, setRedirectUrl } = useRedirectUrl();
 * ${process.env.NEXT_PUBLIC_DEFAULT_HOST}/modoo/storeLogin?url=${redirectUrl};
 * setRedirectUrl({type: ...});
 */ var useRedirectUrl = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var classId = router.query.classId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), url = ref[0], setUrl = ref[1];
    /**
   * 로컬스토리지에 redirect type을 저장한다.
   * @param {object} props
   * @param {'share' | 'payment' | string} props.type
   */ var setRedirectUrl = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var type = param.type;
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
        if (!device.app()) {
            window.localStorage.removeItem('redirectType');
            window.localStorage.setItem('redirectType', type);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
        if (device.app()) {
            return;
        }
        var redirectType = window.localStorage.getItem('redirectType');
        if (!redirectType) {
            return;
        }
        if (redirectType === 'share') {
            return setUrl(window.location.pathname);
        }
        if (redirectType === 'payment') {
            return setUrl("/class/pay/payinfo/".concat(classId));
        }
        if (redirectType === 'reload') {
            return setUrl(window.location.pathname);
        }
        if (/^https?/i.test(redirectType)) {
            return setUrl(redirectType);
        }
    }, [
        router,
        classId,
        setRedirectUrl
    ]);
    return {
        setRedirectUrl: setRedirectUrl,
        redirectUrl: url
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useRedirectUrl);


/***/ })

}]);